import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const CodeReviewerRepoPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./code-reviewer'),
});
